"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showAdjustButton = void 0;
const config_1 = require("config");
const utils_1 = require("utils");
const showAdjustButton = (data) => {
    return (data.status === 'approved' ||
        (config_1.VOIDABLE_STATES.includes(data.status) &&
            (0, utils_1.mapTransactionTypeandInstrumentTypeToProductType)(data.transactionType, data.instrumentType) != config_1.PRODUCT_TYPE_MAP.installment));
};
exports.showAdjustButton = showAdjustButton;
